<template>
  <div>
    <v-alert :value="error" type="error" transition="scale-transition">{{errorMessage}}</v-alert>
    <v-alert :value="success" type="success" transition="scale-transition">{{successMessage}}</v-alert>
    <v-card>
      <v-card-title>
        <span class="headline">نسيت كلمة المرور؟</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="البريد الإلكتروني"
                v-model="email"
                v-validate="'required|email'"
                :error-messages="errors.collect('email')"
                name="email"
                data-vv-as="email"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="dialog = false">إلغاء</v-btn>

        <v-btn :disabled="!valid" color="success" @click="submit">إرسال</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import userService from "../../services/auth-service.js";
export default {
  props: {
    value: Boolean
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      email: null,
      valid: true,
      error: false,
      success: false,
      successMessage: null,
      errorMessage: null
    };
  },
  methods: {
    async submit() {
      this.error = false;
      this.success = false;
      var valid = await this.$validator.validateAll();
      if (valid) {
        try {
          let response = await userService.forgotPassword(this.email);
          this.success = true;
          this.successMessage = response.data.message;
          setTimeout(() => {
            this.$emit("input", false);
          }, 2000);
        } catch (error) {
          this.error = true;
          this.errorMessage = error.message;
        }
      }
    }
  }
};
</script>

